const adminMode = ["/login", "/adm/properties", "/validatePin"];

const useIsAdminMode = (pathName) => {
  return adminMode.includes(pathName);
};

export default useIsAdminMode;
